import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import logger from '@adc/logger';
import { initiateIdentityVerification, performProcessIdUploadVerification, } from './providers';
import { useMountEffect } from '../../hooks';
import { NullComponent } from '../elementals';
export const Jumio = ({ frameUrl, redirectToStatusPage }) => {
    useEffect(() => {
        const receiveMessage = async (event) => {
            let val = null;
            try {
                val = JSON.parse(event?.data ?? '').payload?.value;
                if (val === 'success') {
                    redirectToStatusPage('processing');
                    await performProcessIdUploadVerification();
                    redirectToStatusPage(val);
                }
                else if (val === 'error') {
                    redirectToStatusPage(val);
                }
            }
            catch (e) {
                logger.error('Caught unexpected page message', e);
                redirectToStatusPage('error');
            }
        };
        window.addEventListener('message', receiveMessage, false);
        return () => window.removeEventListener('message', receiveMessage, false);
    }, [frameUrl, redirectToStatusPage]);
    return _jsx("iframe", { src: frameUrl, width: '100%', height: '500px', allow: 'camera' });
};
export const Initialization = ({ frameUrl, setFrameUrl, redirectToStatusPage, }) => {
    useMountEffect(() => {
        if (!!frameUrl)
            return;
        redirectToStatusPage('initializing');
        initiateIdentityVerification()
            .then(response => {
            if (response?.body) {
                setFrameUrl(response.body);
                redirectToStatusPage('initialized');
            }
            else {
                logger.error('No redirect URL found in response', response);
                redirectToStatusPage('error');
            }
        })
            .catch(error => {
            logger.error('Error initiating identity verification', error);
            redirectToStatusPage('error');
        });
    });
    return _jsx(NullComponent, {});
};
const IdVerification = ({ user, redirectToStatusPage, }) => {
    const redirectUrl = user?.verification_status?.redirect_url;
    const [frameUrl, setFrameUrl] = useState(redirectUrl);
    return frameUrl ? (_jsx(Jumio, { frameUrl: frameUrl, redirectToStatusPage: redirectToStatusPage })) : (_jsx(Initialization, { frameUrl: frameUrl ?? '', setFrameUrl: setFrameUrl, redirectToStatusPage: redirectToStatusPage }));
};
export default IdVerification;
//# sourceMappingURL=index.js.map